module.exports = __webpack_public_path__ + "img/adoread.e3e64a8d.png";